import React, { useEffect, useRef, useState } from "react"
import play from "../../assets/images/inbox/play.svg"
import heart from "../../assets/images/inbox/heart.svg"
import commentIcon from "../../assets/images/inbox/message-2.svg"
import { getFormattedTime } from "utils"
import { getMessageAttachment } from "services/quickblox"
import CommentSection from "./commentSection"
import { getInitials } from "./utils"

export default function NewsFeeds(props) {
  const {
    handleLoadMore,
    handleLikeMessage,
    messages,
    selectedChat,
    inboxSession,
    chatUsers,
    getInboxChatUsers,
    likes,
    authUser,
  } = props
  const endOfMessagesRef = useRef(null)
  const [initialLoad, setInitialLoad] = useState(true)

  useEffect(() => {
    if (messages?.items?.length > 0 && initialLoad) {
      endOfMessagesRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      })
    }
    if (messages?.items?.length > 0) {
      getInboxChatUsers({ currentUserList: chatUsers, messages: messages.items })
    }
  }, [messages])

  const [openCommentSections, setOpenCommentSections] = useState(null)
  const toggleCommentSection = messageId => {
    const isOpening = openCommentSections !== messageId
    setOpenCommentSections(isOpening ? messageId : null)
  }

  return (
    <section className="news-feed-wrapper custom-new-scrollbar d-grid h-100 pb-1">
      {messages?.items?.length > 0 && messages.showLoadMore && (
        <div
          className="text-center btn"
          onClick={() => {
            setInitialLoad(false)
            handleLoadMore()
          }}
        >
          Load More Messages
        </div>
      )}
      {messages?.items?.length > 0 ? (
        messages.items?.map((comments, key) => {
          let prevMssgDay, date
          let crrntMssgDay = new Date(comments.created_at).toLocaleDateString()
          if (key === 0)
            date = new Date(comments.created_at).toLocaleDateString()
          else {
            prevMssgDay = new Date(
              messages.items[key - 1].created_at
            ).toLocaleDateString()
            if (prevMssgDay != crrntMssgDay)
              date = new Date(comments.created_at).toLocaleDateString()
            else date = false
          }
          const commentLike = likes.find(
            x => x?.message_qb_id === comments?._id
          )
          const commentSender = chatUsers?.find(
            user => user.chat_credentials.qb_id === comments.sender_id
          )
          const senderName =
            (commentSender?.first_name
              ? commentSender?.first_name + " "
              : "---") +
            (commentSender?.last_name ? commentSender.last_name : "---")
          return (
            <React.Fragment key={key}>
              {date && <div className="w-100 text-center py-2">{date}</div>}
              <div className="news-feed-card">
                <div className="thumbnail-wrapper">
                  <div className="board-thumbnail">
                    {commentSender?.profile_pic?.file?.url ? (
                      <div className="avatar">
                        <img
                          src={commentSender?.profile_pic?.file?.url}
                          alt="Avatar"
                        />
                      </div>
                    ) : (
                      <div className="initial-character direct-messages-in me-3 rounded-circle">
                        <h4 className="m-0 p-0">
                          {getInitials(
                            `${commentSender?.first_name} + ${commentSender?.last_name}`
                          )}
                        </h4>
                      </div>
                    )}
                  </div>
                  <div className="comment-content">
                    <h4 className="d-flex justify-content-between align-items-center">
                      @{senderName}
                    </h4>
                    <h3>
                      {senderName}{" "}
                      <span className="updated-time">
                        {getFormattedTime(comments?.created_at)}
                      </span>
                    </h3>
                  </div>
                </div>
                <div className="news-feed-card-body">
                  <p className="post-description">{comments?.message}</p>
                  <figure className="news-feed-gallery">
                    {comments?.attachments?.length > 0 &&
                      comments?.attachments?.map((file, i) => {
                        if (
                          file?.type === "image" ||
                          file?.type === "photo" ||
                          file?.type?.includes("image")
                        ) {
                          return (
                            <img
                              key={i}
                              src={
                                file?.imageUrl
                                  ? file?.imageUrl
                                  : getMessageAttachment(
                                      file?.id,
                                      inboxSession?.token
                                    )
                              }
                              style={{
                                height: "280px",
                                maxWidth: "100%",
                                objectFit: "fill",
                              }}
                              alt="Attachment"
                              className="gallery-img pb-2"
                            />
                          )
                        }
                        if (
                          file?.type === "video" ||
                          file?.type?.includes("video")
                        ) {
                          return (
                            <video key={i} style={{ maxWidth: "25%" }} controls>
                              <source
                                src={getMessageAttachment(
                                  file?.id,
                                  inboxSession?.token
                                )}
                              />
                            </video>
                          )
                        }
                      })}
                  </figure>
                  <ul className="news-actions">
                    <li
                      className={`${
                        commentLike?.liked_by_me ? "active" : ""
                      } position-relative`}
                    >
                      <img
                        className={`heart ${
                          commentLike?.liked_by_me ? "active" : ""
                        }`}
                        onClick={() => {
                          handleLikeMessage(
                            commentLike,
                            comments?.chat_dialog_id,
                            comments?._id
                          )
                        }}
                        src={heart}
                        alt="Like"
                      />
                      {commentLike?.total_likes > 0 && (
                        <div
                          style={{ fontSize: "9px", width: "fit-content" }}
                          className="likes"
                        >
                          {commentLike?.total_likes} likes
                        </div>
                      )}
                    </li>

                    <li>
                      <img
                        className="commentsIcon"
                        src={commentIcon}
                        alt="Comment"
                        onClick={() => toggleCommentSection(comments?._id, key)}
                      />
                    </li>
                  </ul>
                  {openCommentSections == comments?._id && (
                    <div style={{ marginLeft: "20px" }}>
                      <CommentSection
                        getInitials={getInitials}
                        messageId={comments?._id}
                        authUser={authUser}
                      />
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          )
        })
      ) : (
        <div className="no-message">No Message Yet!</div>
      )}
      <div ref={endOfMessagesRef} />
    </section>
  )
}
